export default "__VITE_ASSET__203f22cb__"